export default "__VITE_ASSET__b41208dd__"